import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-rounded-image',
  templateUrl: './rounded-image.component.html',
  styleUrls: ['./rounded-image.component.scss'],
})
/**
 * Rounded image atom
 */
export class RoundedImageComponent {
  @Input() src?: string;
  @Input() alt?: string;
  private _small = false;
  private _xsmall = false;
  private _xxsmall = false;

  /**
   * Decides if this image size is smaller
   * @return {boolean}
   */
  @Input()
  get small(): boolean {
    return this._small;
  }

  /**
   * Sets this image as small by using an html attribute
   * @param {any} value
   */
  set small(value: any) {
    this._small = coerceBooleanProperty(value);
  }

  /**
   * Decides if this image size is extra small
   * @return {boolean}
   */
  @Input()
  get xsmall(): boolean {
    return this._xsmall;
  }

  /**
   * Sets this image as extra small by using an html attribute
   * @param {any} value
   */
  set xsmall(value: any) {
    this._xsmall = coerceBooleanProperty(value);
  }

  /**
   * Decides if this image size is extra extra small
   * @return {boolean}
   */
  @Input()
  get xxsmall(): boolean {
    return this._xxsmall;
  }

  /**
   * Sets this image as extra extra small by using an html attribute
   * @param {any} value
   */
  set xxsmall(value: any) {
    this._xxsmall = coerceBooleanProperty(value);
  }
}
